import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'

import {Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useSiteContext} from '../../../contexts/site'
import useTagManager from '../../../hooks/use-tag-manager'

const Footer = ({
    onClose,
    handleAddToBag,
    bonuses,
    meterType,
    selectedBonuses,
    isLoading,
    showAddToBagError
}) => {
    const intl = useIntl()
    const tagManager = useTagManager()
    const {isYR} = useSiteContext()
    const isDisabled =
        bonuses?.length === 1 &&
        selectedBonuses?.length === 1 &&
        selectedBonuses?.[0]?.variant?.orderable === false

    return (
        <>
            {showAddToBagError && (
                <Text flex="0 0 100%" width="100%" color="red.400">
                    {intl.formatMessage({
                        id: 'gwp_modal.footer.add_to_bag_error',
                        defaultMessage: 'Please select bonus to your bag before proceeding.'
                    })}
                </Text>
            )}

            <Button
                onClick={onClose}
                flex="1"
                variant="buttonOutline"
                borderColor={isYR ? 'black' : 'purple.700'}
                paddingX={{base: '25px', md: '50px'}}
            >
                {intl.formatMessage({
                    id: 'gwp_modal.footer.no_thanks',
                    defaultMessage: 'No Thanks'
                })}
            </Button>

            <Button
                onClick={() => {
                    if (isDisabled) {
                        if (bonuses?.length === 1) {
                            tagManager.bonusSoldOut(bonuses?.[0], null, meterType)
                        }
                        return
                    }
                    handleAddToBag()
                }}
                cursor="pointer !important"
                isLoading={isLoading}
                variant="button"
                flex="1"
                color={isDisabled ? 'gray.650' : 'white'}
                backgroundColor={isDisabled ? 'gray.40' : isYR ? 'black' : 'purple.700'}
            >
                {isDisabled
                    ? intl.formatMessage({
                          id: 'gwp_modal.footer.sold_out',
                          defaultMessage: 'Sold Out'
                      })
                    : bonuses?.length > 1
                    ? intl.formatMessage({
                          id: 'gwp_modal.footer.confirm',
                          defaultMessage: 'Confirm'
                      })
                    : intl.formatMessage({
                          id: 'gwp_modal.footer.add_to_bag',
                          defaultMessage: 'Add To Bag'
                      })}
            </Button>
        </>
    )
}

Footer.propTypes = {
    onClose: PropTypes.func.isRequired,
    handleAddToBag: PropTypes.func.isRequired,
    bonuses: PropTypes.array.isRequired,
    meterType: PropTypes.string,
    selectedBonuses: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showAddToBagError: PropTypes.bool.isRequired
}

export default Footer
